<template>
  <div>
    <div v-if="loadingTranslations" class="mt-3">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="100"
          width="8"
        ></v-progress-circular>
      </div>
      <v-row justify="center" class="mt-8">
        <v-col cols="2" class="text-center">
          <p class="basic--text">
            Searching for words to translate... Please wait...
          </p>
        </v-col>
      </v-row>
    </div>

    <div v-if="translationsFailed">
      <v-row class="pb-2" justify="center">
        <v-img :src="require(`@/assets/${responseImg}`)" max-width="300">
        </v-img>
      </v-row>
      <v-row class="pb-2 text-center" justify="center">
        <h3 class="basic--text">{{ responseMessage }}</h3>
      </v-row>
      <v-row>
        <v-col cols="1"
          ><v-btn outlined color="error" @click="getProductsForUpload">
            <v-icon left>mdi-arrow-left-bold-outline</v-icon>
            Back
          </v-btn></v-col
        >
        <v-spacer></v-spacer>
      </v-row>
    </div>

    <div v-if="showWordsTable">
      <v-row justify="center">
        <v-col>
          <h2 class="basic--text text-center">
            <v-icon color="secondary"> mdi-translate</v-icon> Translations
          </h2>
          <p class="basic--text text-center">
            Please translate the following words
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              dense
              :items="wordsMap"
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1"
          ><v-btn outlined color="error" @click="getProductsForUpload">
            <v-icon left>mdi-arrow-left-bold-outline</v-icon>
            Back
          </v-btn></v-col
        >
        <v-spacer></v-spacer>
        <v-col cols="1"
          ><v-btn outlined color="success" @click="saveTranslations"
            >Next <v-icon right>mdi-arrow-right-bold-outline</v-icon></v-btn
          ></v-col
        >
      </v-row>
    </div>

    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ProductsToTranslate",
  props: {
    skus: Array,
    platform: Object,
  },
  components: {},
  computed: {
    headers() {
      let headers = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: this.platform.language,
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return headers;
    },
  },
  data: () => ({
    showWordsTable: false,
    loadingTranslations: true,
    translationsFailed: false,
    responseImg: "",
    responseMessage: "",
    wordsMap: [],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    snackbar: false,
    snackbarText: "",
  }),
  async mounted() {
    await this.getProductsToTranslate();
  },
  methods: {
    async getProductsToTranslate() {
      let body = {
        language: "lt",
        skus: this.skus,
      };

      try {
        const response = await this.$store.dispatch(
          "getProductsToTranslate",
          body
        );

        this.wordsMap = await this.mapWords(response.data);
        this.loadingTranslations = false;
        this.showWordsTable = true;
      } catch (error) {
        console.log(error);
        this.loadingTranslations = false;
        this.responseImg = "feeling_blue.svg";
        this.responseMessage = error.response.data
          ? error.response.data
          : "Something went wrong when trying to get products to translate...";
        this.translationsFailed = true;
      }
    },
    async mapWords(words) {
      let result = [];
      result = words.map((word) => {
        return { word, value: "" };
      });
      return result;
    },
    //check if wordsMap contains any empty strings
    validateWordsMap(wordsMap) {
      return wordsMap.find((el) => el.value == "");
    },
    saveTranslations() {
      if (this.$refs.form.validate()) {
        if (!this.validateWordsMap(this.wordsMap)) {
          this.pushTranslations(this.wordsMap);
        } else {
          this.snackbarText = "There are empty fields left in other pages!";
          this.snackbar = true;
        }
      }
    },
    async pushTranslations(wordsMap) {
      let data = await this.formatData(wordsMap);
      this.loadingTranslations = true;

      try {
        const response = await this.$store.dispatch(
          "saveTranslationsOnPlatforms",
          data
        );
        console.log(response);
        this.loadingTranslations = false;
        this.$emit("translatedSuccessfully");
      } catch (error) {
        console.log(error);
        this.loadingTranslations = false;
        this.responseImg = "feeling_blue.svg";
        this.responseMessage = error.response.data
          ? error.response.data
          : "Something went wrong when trying to save translations...";
        this.translationsFailed = true;
      }
    },
    //format data to send to backend
    async formatData(wordsMap) {
      let result = {
        language: this.platform.code,
        translations: {},
      };
      for (let object of wordsMap) {
        result.translations[object.word] = object.value.trim();
      }
      return result;
    },
    getProductsForUpload() {
      this.$emit("getProductsForUpload");
    },
  },
};
</script>

